import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { withLang } from '../../../utils/langPath.ts'
import albumImage from '../../../assets/weddingCamera/usecase-image.png'
import './index.css'

const QrAlbum: React.FC = () => {
	const { t, i18n } = useTranslation('home')
	return (
		<section className='qr-album-section' aria-labelledby='qr-album-title'>
			<div className='qr-album-shell'>
				<figure className='qr-album-visual'>
					<img src={albumImage} alt={t('qrAlbum.imageAlt')} width={1104} height={1142} loading='lazy' />
				</figure>
				<div className='qr-album-content'>
					<h2 id='qr-album-title'>{t('qrAlbum.title')}</h2>
					<p className='qr-album-intro'>{t('qrAlbum.text')}</p>
					<div className='qr-album-details'>
						<details>
							<summary>{t('qrAlbum.sharingTitle')}</summary>
							<p>{t('qrAlbum.sharingText')}</p>
						</details>
						<details>
							<summary>{t('qrAlbum.deliveryTitle')}</summary>
							<p>{t('qrAlbum.deliveryText')}</p>
						</details>
					</div>
					<div className='qr-album-links'>
						<Link className='qr-album-demo' to={withLang(i18n.language, '/demo')}>{t('qrAlbum.demoLink')}</Link>
						<Link className='qr-album-price' to={withLang(i18n.language, '/price')}>{t('qrAlbum.priceLink')}</Link>
						<Link className='qr-album-guide' to={withLang(i18n.language, `/blog/${t('qrAlbum.guideSlug')}`)}>{t('qrAlbum.guideLink')}</Link>
						<Link className='qr-album-guide' to={withLang(i18n.language, '/wedding-photo-app')}>{t('qrAlbum.appLink')}</Link>
					</div>
				</div>
			</div>
		</section>
	)
}

export default QrAlbum
